export default "__VITE_ASSET__CILDeUF___"